import { useEffect, useState } from "react";
import { Col, Container, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";
import ProfileView from "../../components/shared/settings/ProfileView";
import AccountView from "../../components/shared/settings/AccountView";
import SplashPage from "../SplashPage";
import TeamView from "../../components/shared/settings/TeamView";
import { useQuery } from "react-query";
import InvoiceView from "../../components/shared/settings/InvoiceView";
import { useAuthState } from "../../context/AuthContext";

const SettingsPage = () => {

    const API = new PrivateApi(); // API CALL 
    const { user } = useAuthState(); // get user data from auth context
    const [view, setView] = useState("profile"); // Change view 
    const [settingsList, setSettingsList] = useState([]); // list categories


    // get data from api
    const {data, error, isLoading} = useQuery("GET_PROFILE", API.get_UserLogged, {
        staleTime: Infinity
    });

    useEffect(() => {
        var tmpList = [{ key: "profileKey", name: "Kundendaten", active: "profile" }];

        if (data && data.data) {
            if (data.data.x_is_house_management === true) {
                tmpList.push({key: "teamKey", name: "Kontaktpersonen", active: "team"});
                tmpList.push({ key: "invoiceKey", name: "Dokumentenzustellung", active: "invoice" });
            
            } else {
                tmpList.push({ key: "accountKey", name: "Benutzerkonto", active: "account" });
                tmpList.push({ key: "invoiceKey", name: "Dokumentenzustellung", active: "invoice" });
            }
        }
        setSettingsList(tmpList);
    }, [data])


    // if loading or error from api
    if (isLoading) return <SplashPage />
    if (error) return <SplashPage error={"Unbekannter Fehler aufgetreten. Versuchen Sie später."} />

    // gui
    return (
        <Container>
            <Row>
                <Col xs="12">
                    <h3>Einstellungen</h3>
                    <p className="text-muted">Hier können Sie Ihre Daten ändern</p>
                    <hr />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="4" xl="3">
                    <ListGroup className="list-group-flush" defaultActiveKey="profile">
                        {settingsList.length > 0 && settingsList.map(set => (
                            <ListGroupItem
                                key={set.key}
                                action
                                active={view === set.active}
                                onClick={() => setView(set.active)}
                            >{set.name}
                            </ListGroupItem>
                        ))}
                    </ListGroup>
                </Col>
                <Col xs="12" md="8" xl="9">
                    {
                        view === "profile" ?
                            <ProfileView user={data.data} /> 
                        :

                        view === "account" ?
                            <AccountView user={data.data} loggedUser={user} /> 
                        :

                        view === "invoice" ?
                            <InvoiceView user={data.data} />
                        :

                        view === "team" ?
                            <TeamView />
                        :

                        null
                    }
                </Col>
            </Row>
        </Container>
    )
}
export default SettingsPage;